import React, { useState } from "react";
import { FaUserShield, FaMinus, FaPlus, FaCalendarCheck, FaFileInvoiceDollar, FaVideo, FaMobileAlt, FaLaptopMedical, FaHeartbeat, FaRobot, FaBookMedical, FaGlobe, FaPills, FaUserFriends, FaFileMedicalAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const PPES = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Patient Portal & Engagement Solutions</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, We provide secure and user-friendly patient portals that help healthcare organizations enhance patient engagement, improve communication, and streamline care delivery. Our solutions offer real-time access to health records, appointment scheduling, secure messaging, and telehealth integration, ensuring a seamless and patient-centered experience.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4 ">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Secure Patient Portals",
        description: "Provide real-time access to health records, test results, and personalized care plans.",
        icon: FaUserShield
    },
    {
        title: "Seamless Appointment Scheduling",
        description: "Enable easy online booking, rescheduling, and automated reminders for a hassle-free experience.",
        icon: FaCalendarCheck
    },
    {
        title: "Secure Messaging & Telehealth",
        description: "Enhance communication with HIPAA-compliant messaging and virtual consultations.",
        icon: FaVideo
    },
    {
        title: "Personalized Health Insights",
        description: "Offer tailored health recommendations and patient education to improve engagement.",
        icon: FaHeartbeat
    },
    {
        title: "e-Prescription & Medication Management",
        description: "Allow patients to view prescriptions, request refills, and receive medication reminders.",
        icon: FaPills
    },
    {
        title: "Billing & Payment Integration",
        description: "Provide patients with transparent billing, secure payment options, and financial assistance tools.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "Family & Caregiver Access",
        description: "Enable authorized family members and caregivers to manage care and access health information.",
        icon: FaUserFriends
    },
    {
        title: "Symptom Checker & AI Chatbot",
        description: "Offer an AI-powered assistant to guide patients on symptoms, treatments, and next steps.",
        icon: FaRobot
    }
];



const services = [

    {
        title: "Patient Self-Service Tools",
        description: "Enable seamless access to medical records, test results, and treatment history.",
        icon: "FaUserCheck"
    },
    {
        title: "Virtual Health Assistant",
        description: "AI-powered chatbot for appointment booking, FAQs, and symptom guidance.",
        icon: "FaRobot"
    },
    {
        title: "Integrated Health Tracking",
        description: "Connect wearables and health apps to monitor vitals and wellness metrics.",
        icon: "FaHeartbeat"
    },
    {
        title: "Remote Patient Monitoring",
        description: "Real-time tracking of chronic conditions with alerts for providers.",
        icon: "FaStethoscope"
    },
    {
        title: "Personalized Health Insights",
        description: "AI-driven recommendations for preventive care and lifestyle improvements.",
        icon: "FaChartLine"
    },
    {
        title: "One-Touch Telehealth Access",
        description: "Instantly connect with healthcare professionals for virtual consultations.",
        icon: "FaVideo"
    },
    {
        title: "Voice & Chat Interfaces",
        description: "Hands-free patient interactions via voice commands and chatbots.",
        icon: "FaMicrophone"
    },
    {
        title: "Multilingual Support",
        description: "Ensure accessibility for diverse patient populations with language customization.",
        icon: "FaLanguage"
    },
    {
        title: "Data Privacy & Security",
        description: "HIPAA-compliant infrastructure ensuring encrypted communication and storage.",
        icon: "FaShieldAlt"
    }
];

const whyChooseUs = [
    {
        title: "HIPAA & HL7 Compliant",
        description: "We ensure all patient data is secure, encrypted, and regulatory-compliant.",
        icon: "FaLock"
    },
    {
        title: "Seamless EHR Integration",
        description: "Our portals connect with EPIC, Cerner, eClinicalWorks, and other EHRs.",
        icon: "FaServer"
    },
    {
        title: "User-Friendly Design",
        description: "Intuitive UI/UX for enhanced patient engagement and satisfaction.",
        icon: "FaUserFriends"
    },
    {
        title: "Customizable Solutions",
        description: "Tailored features to fit the unique needs of hospitals, clinics, and telehealth providers.",
        icon: "FaCogs"
    },
    {
        title: "Automated Workflows",
        description: "Reduce administrative burdens with automated forms, reminders, and notifications.",
        icon: "FaTasks"
    }, {
        title: "24/7 Health Record Access",
        description: "Patients can securely view their medical history, lab results, and treatment plans.",
        icon: FaUserShield
    },
    {
        title: "Intelligent Appointment Management",
        description: "Enable self-scheduling, reminders, and virtual check-ins for a seamless experience.",
        icon: FaCalendarCheck
    },
    {
        title: "Secure Messaging & Virtual Care",
        description: "HIPAA-compliant messaging, video consultations, and telehealth support.",
        // icon: FaCommentsMedical
    },
    {
        title: "Personalized Health Insights",
        description: "Provide tailored health recommendations, medication reminders, and progress tracking.",
        icon: FaHeartbeat
    },
    {
        title: "Billing & Payment Integration",
        description: "Allow secure online bill payments, insurance claims tracking, and cost estimations.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "Mobile & Web Accessibility",
        description: "Ensure a responsive experience across smartphones, tablets, and desktops.",
        icon: FaMobileAlt
    }
];


const List = [
    {
        title: "Custom Patient Portal Development",
        description: "Fully branded, feature-rich solutions tailored for healthcare organizations.",
        icon: FaLaptopMedical
    },
    {
        title: "EHR & API Integration",
        description: "Seamless connectivity with existing healthcare IT systems for improved interoperability.",
        icon: FaFileMedicalAlt
    },
    {
        title: "Telemedicine & Virtual Care",
        description: "Integrated video consultations, remote monitoring, and e-prescriptions for better care delivery.",
        icon: FaVideo
    },
    {
        title: "Multi-Language & Accessibility Support",
        description: "Enhance usability with language options and accessibility features for diverse patient populations.",
        icon: FaGlobe
    },
    {
        title: "Patient Education & Wellness Tools",
        description: "Provide access to health guides, symptom checkers, and lifestyle tips to promote wellness.",
        icon: FaBookMedical
    }
];



export default PPES;
